<template>
  <InfoTooltip
    :title="t('TOOLTIPS.caseToken.title')"
    :text="t('TOOLTIPS.caseToken.text', { level: tokenCapLevel })"
    position="bottom"
    :disabled="disableTooltip"
  >
    <div class="token-pill">
      <i class="fa-solid fa-ticket"></i>
      {{ caseToken || 0 }}
    </div>
  </InfoTooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import InfoTooltip from '@/components/InfoTooltip.vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useProfileStore } from '@/store/profile'

const { t } = useI18n()
const profileStore = useProfileStore()
const { profile } = storeToRefs(profileStore)
const tokenCapLevel = computed(() => profile.value?.currentLevel ?? 0)

defineProps<{
  caseToken: number
  disableTooltip?: boolean
}>()
</script>

<style scoped lang="scss">
.token-pill {
  margin-left: 6px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 6px;
  background: rgba(255, 193, 7, 0.12);
  border: 1px solid rgba(255, 193, 7, 0.35);
  color: $token-yellow;
  font-weight: 700;
  font-size: 12px;
  cursor: default;

  i {
    color: $token-yellow;
    font-size: 12px;
  }
}
</style>
